module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ignore_once":"Ignore once","ignore_always":"Ignore always","resolve":"Mark as solved"},"fr":{"ignore_once":"Ignorer une fois","ignore_always":"Ignorer toujours","resolve":"Marquer comme résolu"},"de":{"ignore_once":"einmal überspringen","ignore_always":"Immer ignorieren","resolve":"Als gelöst markieren"}}')
  delete Component.options._Ctor
}
